<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">Partner</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
      </div>

      <div class="tab-selector" v-if="isEdit || isWatch">
        <button
          :class="['tab', activeTab === 'id' ? 'active-tab' : '']"
          @click="activeTab = 'id'"
        >
          Bahasa Indonesia
        </button>
        <button
          :class="['tab', activeTab === 'en' ? 'active-tab' : '']"
          @click="activeTab = 'en'"
        >
          Bahasa Inggris
        </button>
      </div>

      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Indonesia</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Nama</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.name"
                class="form-input"
                placeholder="Masukkan Nama"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Deskripsi</p>
              <v-textarea
                :disabled="isWatch"
                placeholder="Tulis deskripsi ...."
                outlined
                rows="3"
                v-model="form.description"
                clearable
                class="form-input"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Kategori</p>
              <v-select
                :disabled="isWatch"
                class="form-input"
                :items="categories"
                v-model="form.category"
                solo
                :item-text="'name'"
                :item-value="'value'"
                placeholder="Pilih Kategori"
              ></v-select>
            </div>
            <div class="content-form">
              <p>Foto Utama</p>
              <v-file-input
                v-model="image_main"
                accept="image/*"
                placeholder="Unggah Berkas Gambar"
                class="form-upload"
                prepend-icon=""
                outlined
                :disabled="isWatch"
              >
                <template
                  v-slot:prepend-inner
                  v-if="isEdit && image_main == null"
                >
                  <ImageModal
                    :src="form.image_url"
                    width="76.31"
                    height="37"
                    radius="3"
                  />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
              <p class="note-file">
                *Rekomendasi dimensi 500 x 500 px. ukuran file maks 1 MB
              </p>
            </div>
            <div class="content-form">
              <p>Foto Kecil</p>
              <v-file-input
                v-model="image_small"
                accept="image/*"
                placeholder="Unggah Berkas Gambar Kecil"
                class="form-upload"
                prepend-icon=""
                outlined
                :disabled="isWatch"
              >
                <template
                  v-slot:prepend-inner
                  v-if="isEdit && image_small == null"
                >
                  <ImageModal
                    :src="form.small_img"
                    width="76.31"
                    height="37"
                    radius="3"
                  />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
              <p class="note-file">
                *Rekomendasi dimensi 100 x 100 px. ukuran file maks 500 KB
              </p>
            </div>
            <div class="content-form">
              <p>Kode</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.code"
                class="form-input"
                placeholder="Masukkan Kode"
                dense
                clearable
              ></v-text-field>
            </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Name</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="formEng.name"
                class="form-input"
                placeholder="Enter Name"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Description</p>
              <v-textarea
                :disabled="isWatch"
                placeholder="Write description ..."
                outlined
                rows="3"
                v-model="formEng.description"
                clearable
                class="form-input"
              ></v-textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="submit-box" v-if="!isWatch">
        <Button
          name="Batalkan"
          outline
          class="me-3"
          @click="$router.push('/partner')"
        />
        <Button
          :name="isEdit ? 'Simpan' : 'Simpan & Publish'"
          :width="isEdit ? '156px' : '200px'"
          @click="onSubmit"
          :disabled="!validData"
          style="background-color: #2d46cf; color: #ffffff"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/ilustration/Loading.vue";
import Button from "../../../components/Button.vue";
import ImageModal from "../../../components/ImageModal.vue";
import Popup from "@/components/others/Popup.vue";
import Arrow from "@/components/icons/Arrow.vue";

export default {
  name: "FormPartner",
  components: {
    Loading,
    Button,
    ImageModal,
    Popup,
    Arrow,
  },
  computed: {
    validData() {
      return (
        this.form.name &&
        this.form.description &&
        this.form.category &&
        this.form.code &&
        (this.isEdit || (this.image_main && this.image_small))
      );
    },
  },
  data() {
    return {
      id: null,
      name: "",
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: "",
      isPopup: false,
      activeTab: "id",
      image_main: null,
      image_small: null,
      categories: [
        { name: "Corporate Training", value: "TRAINING" },
      ],
      form: {
        name: "",
        description: "",
        category: "",
        image_url: "",
        small_img: "",
        code: "",
      },
      formEng: {
        name: "",
        description: "",
      },
    };
  },
  methods: {
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf("watch") >= 0;
      this.isEdit = this.$route.path.lastIndexOf("edit") >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getPartner();
    },
    async getPartner() {
      this.isLoading = true;
      try {
        const resp = await this.$crm_http.get("/v1/partner/" + this.id);
        const data = resp.data.data.partner;
        this.form = {
          name: data.name || "",
          description: data.description || "",
          category: data.category || "",
          image_url: data.image_url || "",
          small_img: data.small_img || "",
          code: data.code || "",
          id: data.id,
        };
        await this.getBilingual();
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const { data } = await this.$crm_http.get(
          `/v1/bilingual/record/${this.id}?table_name=partners&language_code=en`
        );
        const resp = JSON.parse(data.data.bilingual?.translated_data || "{}");
        this.formEng = {
          name: resp.name || "",
          description: resp.description || "",
        };
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        let imageUrl = this.form.image_url;
        let smallImageUrl = this.form.small_img;

        // Upload main image if provided
        if (this.image_main) {
          const imageForm = new FormData();
          imageForm.append("attachment", this.image_main);
          const webRes = await this.$crm_http.post("/v1/upload-file", imageForm);
          imageUrl = webRes.data.data.upload_image_response.url_w_query;
          imageForm.delete("attachment");
        }

        // Upload small image if provided
        if (this.image_small) {
          const imageForm = new FormData();
          imageForm.append("attachment", this.image_small);
          const webRes = await this.$crm_http.post("/v1/upload-file", imageForm);
          smallImageUrl = webRes.data.data.upload_image_response.url_w_query;
          imageForm.delete("attachment");
        }

        const payload = {
          name: this.form.name,
          description: this.form.description,
          category: this.form.category,
          image_url: imageUrl,
          small_img: smallImageUrl,
          code: this.form.code,
        };

        if (this.isEdit) {
          await this.$crm_http.put("/v1/partner/" + this.form.id, payload);
          await this.onSubmitBilingual(imageUrl, smallImageUrl);
        } else {
          await this.$crm_http.post("/v1/partner", payload);
        }

        setTimeout(() => {
          this.$router.push("/partner");
        }, 2000);
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to submit data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual(imageUrl, smallImageUrl) {
      const payload = {
        table_name: "partners",
        record_id: this.id,
        language_code: "en",
        translated_data: JSON.stringify({
          name: this.formEng.name,
          description: this.formEng.description,
          category: this.form.category,
          image_url: imageUrl,
          small_img: smallImageUrl,
          code: this.form.code,
        }),
      };
      try {
        await this.$crm_http.post("/v1/bilingual", payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.checkingType();
  },
};
</script>

<style scoped>
.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}
.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}
.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}
.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}
.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}
.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}
.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.language-section {
  margin-bottom: 30px;
}
.content-form {
  margin-top: 15px;
}
.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}
.form-upload .v-input__slot {
  height: 62px !important;
  background-color: #ffffff !important;
}
.form-upload .v-text-field__details {
  display: none;
}
.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.note-file {
  font-weight: 400;
  font-size: 12px;
  color: #b80f0a;
  margin-bottom: 20px !important;
}
.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}
</style>